// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wapper-buttons[data-v-2b2940ff] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  gap: 1.25rem/* 20px */;\n}\n.space-paragraph[data-v-2b2940ff] {\n  margin-top: 0.5rem/* 8px */;\n  margin-bottom: 0.5rem/* 8px */;\n}\n", ""]);
// Exports
module.exports = exports;
